import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/EnterpriseAuthContext';

/**
 * 404 page (inside the app shell when signed in, standalone otherwise).
 * @returns {JSX.Element} Not found page.
 */
const NotFound = () => {
  const navigate = useNavigate();
  const { state } = useAuth();

  return (
    <Box
      component="section"
      aria-labelledby="not-found-title"
      sx={{
        minHeight: 'var(--q-main-height, 100vh)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 2,
        px: 2,
        py: 6,
      }}
    >
      <Box component="img" src="/not_found_bird.png" alt="" sx={{ width: 'min(260px, 70vw)', height: 'auto' }} />
      <Typography id="not-found-title" component="h1" sx={{ fontSize: { xs: 22, sm: 26 }, fontWeight: 600, letterSpacing: '-0.02em' }}>
        We couldn&apos;t find that page
      </Typography>
      <Typography variant="body2" sx={{ color: 'var(--q-muted, #5E5A54)', maxWidth: 420 }}>
        The link may be out of date, or the item was moved or deleted.
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate(state.isAuthenticated ? '/home' : '/')}
        sx={{ mt: 1, borderRadius: 'var(--q-radius-pill, 999px)', textTransform: 'none', px: 3 }}
      >
        Back to Home
      </Button>
    </Box>
  );
};

export default NotFound;
